import {BaseService} from "./base.service";

class PaymentplanService extends BaseService {
    constructor() {
        super('api/payment-plan');
    }
}

export const paymentplanService = new PaymentplanService();
